import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const uploadToCloudinary = async (file, folder, authHeader) => {
  try {
    // Get signature from backend
    const signatureRes = await axios.get(
      `${API_URL}/cloudinary/signature?folder=${folder}`,
      { headers: authHeader }
    );
    
    const { signature, timestamp, cloud_name, api_key } = signatureRes.data;
    
    // Upload to Cloudinary
    const formData = new FormData();
    formData.append('file', file);
    formData.append('api_key', api_key);
    formData.append('timestamp', timestamp);
    formData.append('signature', signature);
    formData.append('folder', folder);
    
    const uploadRes = await axios.post(
      `https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`,
      formData
    );
    
    return {
      success: true,
      url: uploadRes.data.secure_url,
      public_id: uploadRes.data.public_id
    };
  } catch (error) {
    console.error('Cloudinary upload error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export const uploadPdfToCloudinary = async (file, folder, authHeader) => {
  try {
    // Get signature from backend
    const signatureRes = await axios.get(
      `${API_URL}/cloudinary/signature?folder=${folder}&resource_type=raw`,
      { headers: authHeader }
    );
    
    const { signature, timestamp, cloud_name, api_key } = signatureRes.data;
    
    // Upload to Cloudinary
    const formData = new FormData();
    formData.append('file', file);
    formData.append('api_key', api_key);
    formData.append('timestamp', timestamp);
    formData.append('signature', signature);
    formData.append('folder', folder);
    
    const uploadRes = await axios.post(
      `https://api.cloudinary.com/v1_1/${cloud_name}/raw/upload`,
      formData
    );
    
    return {
      success: true,
      url: uploadRes.data.secure_url,
      public_id: uploadRes.data.public_id
    };
  } catch (error) {
    console.error('Cloudinary upload error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};
